export default __webpack_public_path__ + "static/intercom-c28279aada5d86ffd14afc49b477af84.svg";